import { useSearchParams } from 'react-router';

import { URL_PARAMS } from '@/constants/url-params.ts';
import { TSortType } from '@/types.ts';

type THookRes = {
    sort: TSortType;
};

export const useSorting = (): THookRes => {
    const [searchParams] = useSearchParams();

    const isSortDirection = (value: string | null): value is 'asc' | 'desc' => {
        return value === 'asc' || value === 'desc';
    };

    const direction = searchParams.get(URL_PARAMS.SORT_DIRECTION);

    return {
        sort: {
            sort_direction: isSortDirection(direction) ? direction : undefined,
            sort_by: searchParams.get(URL_PARAMS.SORT_BY) || undefined,
        },
    };
};
